import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import IconArrowDown from '-!svg-react-loader!../icon-arrow-down.svg';

const Container = styled.div`
    position:relative;
    height: 100%;
    color: #393939;
`;

const InputContainer = styled.div`
    position: relative;
    height: 100%;
    border-radius: 6px;
    background-color: #fff;
    border: solid 1px #eee;    
    overflow: hidden;
`;

const TextInput = styled.input`        
    background-color: transparent;
    border: 0;
    outline-width: 0;
    padding: 0 32px 0 10px;
    width: 100%;
    height: 100%;
    font-size: 14px;
`;

const ReadonlyInput = styled.div`    
    height:100%;
    padding: 0 32px 0 10px;
    cursor: pointer;
    font-size: 14px;
`;

const HeightAdjustment = styled.div`
    height: 100%;    
    display: inline-block;
    vertical-align: middle;
`;

const DropDownBtn = styled(IconArrowDown) `
{
    position: absolute;
    right: 0;
    width: 8px;
    height: 100%;    
    padding: 0;
    margin-right: 12px;
    cursor: pointer;    
    fill: none;
    stroke:#5d5d5d;
}`;

const DropDown = styled.ul`
    position: absolute;
    top: 100%;
    width: 100%;    
    box-sizing: border-box;
    border: solid #f2f2f2 1px;
    border-top:none;
    background-color: #fff;
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow: auto;
    z-index: 999;
`;

const DropDownOption = styled.li`
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background-color: #f2f2f2;
    }
`;

class Dropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            selectedOption: this.props.options.find(o => o.selected === true)
        };

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.showDropdown = this.showDropdown.bind(this);
        this.hideDropdown = this.hideDropdown.bind(this);
        this.toggleClickOutsideEvent = this.toggleClickOutsideEvent.bind(this);
        this.getInputField = this.getInputField.bind(this);
    }

    componentWillUnmount() {
        this.toggleClickOutsideEvent(false);
    }

    handleTextChange(e) {
        this.props.onChange(e.target.value);
    }

    handleOptionChange(e) {        
        let selectedValue = e.target.dataset.value;
        this.setState({ selectedOption: this.props.options.find(o => o.value === selectedValue) });
        this.props.onChange(selectedValue);
        this.hideDropdown();
    }

    showDropdown() {                
        this.toggleClickOutsideEvent(true);
        this.setState({ expanded: true });
    }

    hideDropdown() {                
        this.toggleClickOutsideEvent(false);
        this.setState({ expanded: false });
    }

    toggleClickOutsideEvent(enabled) {
        if (enabled) {
            if (!document.addEventListener && document.attachEvent) {
                document.attachEvent('onclick', this.hideDropdown);
            } else {
                document.addEventListener('click', this.hideDropdown);
            }
        } else {
            if (!document.removeEventListener && document.detachEvent) {
                document.detachEvent('onclick', this.hideDropdown);
            } else {
                document.removeEventListener('click', this.hideDropdown);
            }
        }
    }

    getInputField(){        
        if (this.props.editable) {
            let placeholder = this.props.options[0].text;            
            return <TextInput className={"dropdown__input"} type={"number"} value={this.props.value} placeholder={placeholder} onChange={this.handleTextChange}/>;
        } else {
            let label = this.state.selectedOption ? this.state.selectedOption.text : this.props.options[0].text;
            let formattedLabel = this.props.boldedSelectedValue ?
                <span>{this.props.prefix}<b>{label}</b></span> :
                <span>{this.props.prefix}{label}</span>;
            return <ReadonlyInput className={"dropdown__input-readonly"} onClick={this.showDropdown}><HeightAdjustment />{formattedLabel}</ReadonlyInput>;
        }
    }

    render() {      
        return (
            <Container className={"dropdown"}>
                {this.state.expanded &&
                    <DropDown className={"dropdown__options"} >
                        {this.props.options.map((x, i) =>
                            <DropDownOption className={"dropdown__option"} key={i} data-value={x.value} onClick={this.handleOptionChange}>{x.text}</DropDownOption>
                        )}
                    </DropDown>
                }
                <InputContainer>
                    <DropDownBtn className={"dropdown__btn"} onClick={this.showDropdown} />
                    {this.getInputField()}
                </InputContainer>
            </Container>
        );
    }
}

Dropdown.defaultProps = {
    editable: false,
    boldedSelectedValue: false,
    prefix: ""
};

Dropdown.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    editable: PropTypes.bool,
    boldedSelectedValue: PropTypes.bool,
    prefix: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Dropdown;